import { CalendarClock, ClipboardList, CreditCard, LayoutDashboard, Megaphone, Settings, UserPlus, Users, Wallet } from "lucide-react";

export const staffNavItems = [
  { label: "Overview", path: "/staff", icon: LayoutDashboard, end: true },
  { label: "Schedule", path: "/staff/schedule", icon: CalendarClock },
  { label: "Enrollments", path: "/staff/enrollments", icon: CreditCard },
  { label: "Leads", path: "/staff/leads", icon: UserPlus },
  { label: "Payments", path: "/staff/payments", icon: Wallet },
  { label: "Announcements", path: "/staff/announcements", icon: Megaphone },
  { label: "Players", path: "/staff/players", icon: Users },
  { label: "Assessments", path: "/staff/assessments", icon: ClipboardList },
  { label: "Settings", path: "/staff/settings", icon: Settings },
];
